
import { mapActions, mapMutations } from "vuex";
import { BUSINESS_CREATED } from "@/constants/MixpanelEvents.js";
import createRestaurantForm from "../../components/restaurant/create-restaurant-form.vue";
import SignupCreateBusinessAccount from "../../components/restaurant/signup-create-business-account.vue";
export default {
  components: {
    createRestaurantForm,
    SignupCreateBusinessAccount
  },
  layout: "logoAndAvatar",
  data() {
    return {
      CREATE_BUSINESS_ACCOUNT: "create-business-account",
      CREATE_FORM: "create-form",
      state: "",
      loading: false,
      business: {
        name: "",
        business_type: "",
        country: "India",
        no_of_location: "",
        referral_code: "",
        platform: "web",
        locations_attributes: [
          {
            name: "",
            latitude: "",
            longitude: "",
            address: "",
            zip_code: "",
            time_zone: "Chennai",
            restaurants_attributes: []
          }
        ]
      },

      restaurant: {
        name: "",
        place: "",
        zipCode: "",
        country: "in",
        channels: []
      }
    };
  },
  created() {
    this.state = this.CREATE_BUSINESS_ACCOUNT;
  },
  computed: {
    hasMultipleBrands() {
      return (
        this.business.business_type ===
        this.$constants.BusinessTypes.MULTIPLE_BRAND_SINGLE_OUTLET.id
      );
    }
  },
  methods: {
    ...mapActions("restaurant", ["createBusiness"]),
    ...mapMutations("restaurant", ["SET_BUSINESS_DETAILS"]),

    setBusiness(data) {
      this.business = data;
    },
    switchComponent(state) {
      this.state = state;
    },

    handleBusinessAccountCreation(data) {
      this.setBusiness(data);
      this.switchComponent(this.CREATE_FORM);
    },
    submitRestaurantForm(data) {
      this.setBusiness(data);
      this.addBusiness();
    },

    switchToAddChannel(restaurant) {
      this.restaurant = restaurant;
      this.switchComponent(this.ADD_CHANNELS);
    },
    submitAddChannels(restaurant) {
      this.restaurant = restaurant;
      this.switchComponent(this.CONFIGURE_CHANNELS);
    },
    addBusiness() {
      // this.restaurant = restaurant;
      this.loading = true;
      // let channelPayload = [];
      // this.restaurant.channels.forEach((channel) => {
      //   channelPayload.push({
      //     name: channel.name,
      //     restaurant_url: channel.channelUrl,
      //     access_key: channel.channelId
      //   });
      // });

      // let payload = {
      //   name: this.restaurant.name,
      //   place: this.restaurant.place,
      //   address: this.restaurant.address,
      //   latitude: this.restaurant.latitude,
      //   longitude: this.restaurant.longitude,
      //   country: this.restaurant.country,
      //   zip_codes: this.restaurant.zipCode,
      //   time_zone: "Chennai",
      //   platform: "web",
      //   // channel_settings: channelPayload,
      //   business_type: this.businessType
      // };
      // if (this.hasMultipleBrands) {
      //   payload.brands_attributes = this.brands.map((el) => {
      //     return { name: el };
      //   });
      // }

      let payload = this.business;
      this.createBusiness(payload)
        .then((response) => {
          if (response.status === 200) {
            this.mixPanelTrackEvent(BUSINESS_CREATED);
            this.SET_BUSINESS_DETAILS(response.data);
            this.$router.push({
              name: "restaurant-device-preferences"
            });
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    navigateToSignupPage() {
      this.$router.push({ name: "signup" });
    }
  }
};
